// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel{background-color:#f7f7f9;position:relative}`, "",{"version":3,"sources":["webpack://./src/common/components/Panel/Panel.scss"],"names":[],"mappings":"AAAA,OACE,wBAAA,CACA,iBAAA","sourcesContent":[".panel {\n  background-color: #f7f7f9;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
